// import local dependencies - router and routes
import Router from './util/Router';
import common from './routes/common';
import contactUs from './routes/contactUs';
import faqs from './routes/faqs';
import buyAHome from './routes/buyAHome';
import gettingPreApproved from './routes/gettingPreApproved';
import home from './routes/home';
import homeLoanOptions from './routes/homeLoanOptions';
import mortgageCalculators from './routes/calculators';
import reviews from './routes/reviews';
import scheduleConsultation from './routes/scheduleConsultation';
import vaLoans from './routes/vaLoans';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Contact Us page
  contactUs,
  // FAQs page
  faqs,
  // First Time Homebuyer pages
  buyAHome,
  // Getting Pre-Approved page
  gettingPreApproved,
  // Home page
  home,
  // Home Loan Options page
  homeLoanOptions,
  // Mortgage Calculators page
  mortgageCalculators,
  // Reviews page
  reviews,
  // Schedule A Consultation page
  scheduleConsultation, 
  // VA Loans page
  vaLoans,
});

/** Load Events */
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js